import React from 'react';

const InsuranceCarousel = () => {
  // Major insurance companies in Ontario/Canada
  const insuranceCompanies = [
    'Intact Insurance',
    'Aviva',
    'Desjardins',
    'TD Insurance',
    'Allstate',
    'Belairdirect',
    'The Co-operators',
    'Wawanesa',
    'RSA',
    'Economical',
    'State Farm',
    'CAA Insurance',
    'Sonnet',
    'Gore Mutual',
    'The Personal',
    'AIG',
    'Chubb'
  ];

  return (
    <section className="py-16 bg-[#0a0a0a] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            We Work With All Insurance Companies
          </h2>
          <p className="text-gray-400 text-lg">
            Direct billing available • Claims assistance • Serving the GTA
          </p>
        </div>
      </div>

      {/* Scrolling Carousel - Reverse Direction */}
      <div className="relative">
        <div className="flex overflow-hidden">
          <div className="flex animate-scroll-reverse">
            {insuranceCompanies.concat(insuranceCompanies).map((company, index) => (
              <div
                key={`${company}-${index}`}
                className="flex-shrink-0 mx-6 w-40 h-24 bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg flex items-center justify-center hover:bg-white/10 hover:border-[#ff6b35]/30 transition-all duration-300"
              >
                <span className="text-white font-medium text-sm text-center px-3">
                  {company}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsuranceCarousel;
